exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style_canvas__2Pzb0 {\n    position: absolute;\n    z-index: -1;\n    position: absolute;\n}\n\n@media only screen and (min-width: 600px){\n    \n}", ""]);

// Exports
exports.locals = {
	"canvas": "style_canvas__2Pzb0"
};